import { useContext } from "react";
import { CheckInOutOprWr } from "../../../network/check-out-in/CheckInOutOpr";
import OperationTypes from "../../types";
import { ContextOperation } from "../../context/OperationContext";
import { Parser } from "../../utils";

interface Props {
  currentBatteryPercentage: number;
  brandDescription: string;
  enginePowerGroupCode: string;
  currentFuelLevelEighths: number;
  currentKms: number;
  modelDescription: string;
  plate: string;
  callbackButtonLabel: string;
  carClass: string;
  oprCallback: (obj: OperationTypes.CheckInOutType.retObject) => void;
  tenant?: string;
  viewType?: "oprOut" | "oprIn" | "ddt" | "dataUpd";
  debug?: boolean;
  bypassDamagesEquipments?: boolean;
  enableCounterPart?: boolean;
}

const CheckInOutWrapper = (props: Props) => {
  const { tenant } = useContext(ContextOperation);

  const onCallBack = (obj: any) => {
    if (props.debug){
      console.log(obj);
    }

    props.oprCallback(obj);
  }

  return (
    <CheckInOutOprWr
      currentBatteryPercentage={props.currentBatteryPercentage}
      brandDescription={props.brandDescription}
      enginePowerGroupCode={Parser.enginePowerCode2Description(props.enginePowerGroupCode)}
      currentFuelLevelEighths={props.currentFuelLevelEighths}
      currentKms={props.currentKms}
      modelDescription={props.modelDescription}
      plate={props.plate}
      viewType={props.viewType || "oprOut"}
      callbackButtonLabel={props.callbackButtonLabel}
      carClass={props.carClass}
      tenant={props.tenant || tenant}
      oprCallback={onCallBack}
      bypassDamagesEquipments={props.bypassDamagesEquipments}
	  enableCounterPart={props.enableCounterPart}
    />
  )
}

export default CheckInOutWrapper;